import { Button, Checkbox, Collapse, DatePicker, Divider, Drawer, Input } from "antd";
import { useState } from "react";
import dayjs from "dayjs";

import { useTranslation } from "../../../../context/TranslationContext";
const { RangePicker } = DatePicker;

const OrderListFilter = ({ isOpen, onClose, filter, setFilter }) => {
  const { t } = useTranslation();
  const [newState, setNewState] = useState({
    ...filter,
    searchTimeSloteList: filter.timeSlot || [],
    searchOrderTypeList: filter.orderType || [],
    searchBranchList: filter.branch || [],
    searchZoneList: filter.zone || [],
    searchVendorList: filter.vendor || [],
    searchDriverList: filter.driver || [],
    searchDropzoneList: filter.dropzone || [],
    searchDeliverTypeList: filter.deliverType || [],
  });

  // const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm] = useState("");
  const [searchTermZone] = useState("");
  const [searchVendor] = useState("");
  const [searchDriver] = useState("");
  const [searchDropzone] = useState("");

  // const handleItemClick = (index) => {
  //   setSelectedItem(selectedItem === index ? null : index);
  // };

  //rest all filters
  const resetFilters = () => {
    for (let i in filter.timeSlot) {
      const updatedFilter = { ...newState };
      updatedFilter["timeSlot"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.status) {
      const updatedFilter = { ...newState };
      updatedFilter["status"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.branch) {
      const updatedFilter = { ...newState };
      updatedFilter["branch"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.zone) {
      const updatedFilter = { ...newState };
      updatedFilter["zone"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.vendor) {
      const updatedFilter = { ...newState };
      updatedFilter["vendor"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.driver) {
      const updatedFilter = { ...newState };
      updatedFilter["driver"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.dropzone) {
      const updatedFilter = { ...newState };
      updatedFilter["dropzone"][i].isActive = false;
      setNewState(updatedFilter);
    }
    for (let i in filter.deliverType) {
      const updatedFilter = { ...newState };
      updatedFilter["deliverType"][i].isActive = false;
      setNewState(updatedFilter);
    }

    setFilter(newState);

    setFilter((prev) => ({
      ...prev,
      startdate: null,
      enddate: null,
    }));
  };

  // Handle the date change from the RangePicker
  const handleDateChange = (dates, dateStrings) => {
    const [startdate, enddate] = dateStrings; // Get the date strings from the RangePicker

    // Update the filter with the selected start and end dates
    setNewState((prevState) => ({
      ...prevState,
      startdate: startdate, // Set the start date
      enddate: enddate, // Set the end date
    }));
  };

  // //handle manage onclick
  // const handleStatusClick = (index, category) => {
  //   const updatedFilter = { ...newState };
  //   updatedFilter[category][index].isActive =
  //     !updatedFilter[category][index].isActive;
  //   setNewState(updatedFilter);
  // };

  // handle manage onclick
  const handleStatusClick = (code, category) => {
    // Create a copy of the current state
    const updatedFilter = { ...newState };
    // Find the item in the specified category array by its ID
    const itemToUpdate = updatedFilter[category].find((item) => item.code === code);

    // If the item is found, toggle its isActive property
    if (itemToUpdate) {
      itemToUpdate.isActive = !itemToUpdate.isActive;

      // Update the state with the modified filter
      setNewState(updatedFilter);
    } else {
      console.error(`Item with ID ${code} not found in category ${category}`);
    }
  };

  //handle submit
  const handleSubmit = () => {
    setFilter(newState);
  };

  const filterItems = (keyword, list, listToUpdate) => {
    const filtered = list?.filter((item) => item?.name?.toLowerCase()?.includes(keyword.toLowerCase()));
    // .slice(0, 7); // Slice to include only the first 7 items
    if (filtered?.length === 0) {
      setNewState((prev) => {
        return {
          ...prev,
          [listToUpdate]: [],
        };
      });
    } else {
      setNewState((prev) => {
        return {
          ...prev,
          [listToUpdate]: filtered,
        };
      });
    }
  };

  const { Panel } = Collapse;
  const { Search } = Input;
  return (
    <Drawer
      title={t("allFilters")}
      onClose={onClose}
      open={isOpen}
      footer={
        <>
          <div className="flex justify-end py-1 gap-2">
            <Button className="w-full inline-btn" onClick={resetFilters}>
              {t("reset")}
            </Button>
            <Button className="w-full" type="primary" onClick={handleSubmit}>
              {t("showResult")}
            </Button>
          </div>
        </>
      }
    >
      <div role="presentation" className="w-full overflow-auto">
        <div className="h-[calc(100%-54px)] overflow-auto">
          <div className="flex flex-col mb-5 w-full mx-auto">
            <p className="font-semibold text-sm">{t("dateRange")}</p>
            <div className="mt-[8px]">
              <RangePicker
                className="h-[39px] w-full"
                onChange={handleDateChange}
                defaultValue={
                  filter.startdate && filter.enddate ? [dayjs(filter.startdate, "YYYY-MM-DD"), dayjs(filter.enddate, "YYYY-MM-DD")] : null
                }
                format={"YYYY-MM-DD"}
              />
            </div>
          </div>
          <Divider className="m-0" />
          <div className="collapse-simple flex flex-col my-5 w-full mx-auto gap-3">
            <Collapse accordion bordered={false}>
              <Panel header={t("timeslot")} key="1">
                <div className="flex flex-wrap gap-3.5 mt-[16px]">
                  {newState?.searchTimeSloteList?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`cursor-pointer w-[137px] p-[10px] rounded text-sm ${item.isActive ? "bg-green-300" : "bg-gray-300"}`}
                        onClick={() => handleStatusClick(item.code, "timeSlot")}
                      >
                        {item.name}
                      </div>
                    );
                  })}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("orderType")} key="4">
                {/* <div className="mt-[16px]">
                  <Checkbox className="mt-[10px]">QC, Delivery & Payment</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">QC & Payment</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Delivery & Payment</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">QC</Checkbox>
                </div> */}
                {newState.searchOrderTypeList
                  ?.filter((value) => value.name.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((value, index) => (
                    <Checkbox
                      key={index}
                      className="mt-[10px] flex items-center"
                      checked={newState.orderType.find((item) => item.code === value?.code)?.isActive}
                      onChange={() => handleStatusClick(value?.code, "orderType")}
                    >
                      {value?.name}
                    </Checkbox>
                  ))}
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            {/* <Collapse accordion bordered={false}>
              <Panel header="Status" key="2">
                <Checkbox
                  className="mt-[16px]"
                  checked={
                    newState.status.find((item) => item.code === "initiated")
                      ?.isActive
                  }
                  onChange={() => handleStatusClick("initiated", "status")}
                >
                  Initiated
                </Checkbox>
                <br />
                <Checkbox
                  className="mt-[7px]"
                  checked={
                    newState.status.find(
                      (item) => item.code === "not-initiated"
                    )?.isActive
                  }
                  onChange={() => handleStatusClick("not-initiated", "status")}
                >
                  Not Initiated
                </Checkbox>
                <br />
                <Checkbox
                  className="mt-[7px]"
                  checked={
                    newState.status.find((item) => item.code === "approved")
                      ?.isActive
                  }
                  onChange={() => handleStatusClick("approved", "status")}
                >
                  Approved
                </Checkbox>
              </Panel>
            </Collapse>
            <Divider className="m-0" /> */}
            <Collapse accordion bordered={false}>
              <Panel header={t("branch")} key="3">
                <div className="mt-[16px]">
                  <Search
                    placeholder={t("search")}
                    // onSearch={onSearch}
                    style={{
                      width: 300,
                    }}
                    className=" mx-1.5 cursor-pointer long-height"
                    onChange={(e) => {
                      filterItems(e.target.value.trimStart(), newState?.branch, "searchBranchList");
                    }}
                  />
                  {/* {
                    allBranch?.map((value,index)=>{
                      return (
                        <>
                        <Checkbox key={index} className="mt-[10px] flex items-center">{value.name}</Checkbox>                        
                        </>
                      )                     
                    })
                  } */}
                  {newState.searchBranchList
                    ?.filter((value) => value.name.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((value, index) => (
                      <Checkbox
                        key={index}
                        value={value.id}
                        className="mt-[10px] flex items-center"
                        checked={newState.branch.find((item) => item.code === value?.code)?.isActive}
                        onChange={() => handleStatusClick(value?.code, "branch")}
                      >
                        {value?.name} - {value?.address}
                      </Checkbox>
                    ))}
                  {/* <Checkbox className="mt-[10px] flex items-center">Cakes N Craft - Scheme number 54 Vijay nagar square</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px] flex items-center">Cakes N Credit - New palasia near naffes restaurant</Checkbox>
                  <br />                   */}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("zone")} key="4">
                <div className="mt-[16px]">
                  <Search
                    placeholder={t("search")}
                    // onSearch={onSearch}
                    style={{
                      width: 300,
                    }}
                    className="mx-1.5 cursor-pointer long-height"
                    onChange={(e) => {
                      filterItems(e.target.value.trimStart(), newState?.zone, "searchZoneList");
                    }}
                  />
                  {newState.searchZoneList
                    ?.filter((value) => value.name.toLowerCase().includes(searchTermZone.toLowerCase()))
                    .map((value, index) => (
                      <Checkbox
                        key={index}
                        value={value.id}
                        className="mt-[10px] flex items-center"
                        checked={newState.zone.find((item) => item.code === value?.code)?.isActive}
                        onChange={() => handleStatusClick(value?.code, "zone")}
                      >
                        {value.name}
                      </Checkbox>
                    ))}
                  {/* <Checkbox className="mt-[10px]">Riyadh</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Sakara</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Jazan</Checkbox>
                  <div className="mt-[7px] underline text-green-300 font-semibold ml-[14px] cursor-pointer">
                    See more
                  </div> */}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("vendor")} key="4">
                <div className="mt-[16px]">
                  <Search
                    placeholder={t("search")}
                    // onSearch={onSearch}
                    style={{
                      width: 300,
                    }}
                    className="mx-1.5 cursor-pointer long-height"
                    onChange={(e) => {
                      filterItems(e.target.value.trimStart(), newState?.vendor, "searchVendorList");
                    }}
                  />
                  {newState.searchVendorList
                    ?.filter((value) => value.name.toLowerCase().includes(searchVendor.toLowerCase()))
                    .map((value, index) => (
                      <Checkbox
                        key={index}
                        value={value.id}
                        className="mt-[10px] flex items-center"
                        checked={newState.vendor.find((item) => item.code === value?.code)?.isActive}
                        onChange={() => handleStatusClick(value?.code, "vendor")}
                      >
                        {value.name}
                      </Checkbox>
                    ))}
                  {/* <Checkbox className="mt-[10px]">Riyadh</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Sakara</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Jazan</Checkbox>
                  <div className="mt-[7px] underline text-green-300 font-semibold ml-[14px] cursor-pointer">
                    See more
                  </div> */}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("dropzone")} key="4">
                <div className="mt-[16px]">
                  <Search
                    placeholder={t("search")}
                    style={{
                      width: 300,
                    }}
                    className="mx-1.5 cursor-pointer long-height"
                    onChange={(e) => {
                      filterItems(e.target.value.trimStart(), newState?.dropzone, "searchDropzoneList");
                    }}
                  />
                  {newState.searchDropzoneList
                    ?.filter((value) => value.name.toLowerCase().includes(searchDropzone.toLowerCase()))
                    .map((value, index) => (
                      <Checkbox
                        key={index}
                        value={value.id}
                        className="mt-[10px] flex items-center"
                        checked={newState.dropzone.find((item) => item.code === value?.code)?.isActive}
                        onChange={() => handleStatusClick(value?.code, "dropzone")}
                      >
                        {value.name}
                      </Checkbox>
                    ))}
                  {/* <Checkbox className="mt-[10px]">Riyadh</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Sakara</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Jazan</Checkbox>
                  <div className="mt-[7px] underline text-green-300 font-semibold ml-[14px] cursor-pointer">
                    See more
                  </div> */}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("driver")} key="4">
                <div className="mt-[16px]">
                  <Search
                    placeholder={t("search")}
                    style={{
                      width: 300,
                    }}
                    className="mx-1.5 cursor-pointer long-height"
                    onChange={(e) => {
                      filterItems(e.target.value.trimStart(), newState?.driver, "searchDriverList");
                    }}
                  />
                  {newState.searchDriverList
                    ?.filter((value) => value.name.toLowerCase().includes(searchDriver.toLowerCase()))
                    .map((value, index) => (
                      <Checkbox
                        key={index}
                        value={value.id}
                        className="mt-[10px] flex items-center"
                        checked={newState.driver.find((item) => item.code === value?.code)?.isActive}
                        onChange={() => handleStatusClick(value?.code, "driver")}
                      >
                        {value.name}
                      </Checkbox>
                    ))}
                  {/* <Checkbox className="mt-[10px]">Riyadh</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Sakara</Checkbox>
                  <br />
                  <Checkbox className="mt-[7px]">Jazan</Checkbox>
                  <div className="mt-[7px] underline text-green-300 font-semibold ml-[14px] cursor-pointer">
                    See more
                  </div> */}
                </div>
              </Panel>
            </Collapse>
            <Divider className="m-0" />
            <Collapse accordion bordered={false}>
              <Panel header={t("deliveryType")} key="5">
                <div className="mt-[16px]">
                  {newState.searchDeliverTypeList?.map((value, index) => (
                    <Checkbox
                      key={index}
                      className="mt-[10px] flex items-center"
                      checked={newState.deliverType.find((item) => item.code === value?.code)?.isActive}
                      onChange={() => handleStatusClick(value?.code, "deliverType")}
                    >
                      {value?.name}
                    </Checkbox>
                  ))}
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
export default OrderListFilter;
